module.exports = __webpack_public_path__ + "img/4-8214.defe425a.png";